import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.63 11.815c0 5.42-4.394 9.815-9.815 9.815C6.395 21.63 2 17.236 2 11.815 2 6.395 6.394 2 11.815 2c5.42 0 9.815 4.394 9.815 9.815",
    stroke: "#FFF",
    "stroke-width": "3",
    fill: "#d2e024"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.053 10.808a1.51 1.51 0 1 1-3.02 0 1.51 1.51 0 0 1 3.02 0M13.577 10.808a1.51 1.51 0 1 0 3.02 0 1.51 1.51 0 0 0-3.02 0M11.94 16.848c-2.023 0-3.035-1.539-3.077-1.604a.425.425 0 0 1 .14-.595.451.451 0 0 1 .611.136c.034.051.807 1.2 2.327 1.2 1.503 0 2.322-1.194 2.33-1.206.134-.2.41-.256.614-.125.206.13.263.397.13.597-.044.065-1.095 1.597-3.074 1.597",
    fill: "#000"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}